import React from 'react';
import { Alert, Button, Input, Select } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import { isEmpty, join, prop, reject } from 'ramda';
import BaseModal from '../../../../../components/BaseModal';
import useUserForm from '../../../../../hooks/useUserForm';
import withUser from '../../../../../withUser';
import RoleCardList from './RoleCardList';

const UserModal = ({ user: connectedUser, open, handleClose, selectedUser, teams, offers, users, selectUserByEmail, isAdministration, defaultTeamId }) => {
  const {
    isEditMode,
    onConfirm,
    onDelete,
    onAdd,
    onAddSuperAdmin,
    email,
    setEmail,
    selectedTeam,
    setSelectedTeam,
    selectedOffers,
    setSelectedOffers,
    selectedRole,
    setSelectedRole,
    displayUpdateUserMsg,
    teamsOption,
    offersOption,
    rolesOption,
    rolesDisplayed,
    resetUserForm,
    validations,
    isPendingUser,
    loading
  } = useUserForm({
    open, handleClose, selectedUser, teams, offers, users, isAdministration, defaultTeamId, connectedUser
  });

  const onSelectExistingUser = () => {
    resetUserForm();
    selectUserByEmail(email);
  };

  const {
    disableForm,
    disabledTeamSelect,
    disabledRoleSelect,
    disabledOfferSelect,
    disabledAddRoleBtn,
    disableConfirmModal
  } = validations;

  const existingUserBaseDescription = 'Cet utilisateur possède déjà un compte dans FlexiDocs.';
  const existingUserDescriptionDetails = isPendingUser
    ? 'Ce compte est en attente de finalisation par l’utilisateur et ne peut pas être modifié pour le moment.'
    : !disableConfirmModal
      ? 'Vous pouvez modifier ses rôles ou ajouter un autre utilisateur.'
      : '';
  const existingUserDescription = join(' ', reject(isEmpty, [existingUserBaseDescription, existingUserDescriptionDetails]));

  return (
    <BaseModal
      title={isEditMode ? 'Modifier les rôles': 'Ajouter un utilisateur'}
      visible={open}
      onHide={() => handleClose(false)}
      width={600}
      disabled={disableConfirmModal}
      onClick={displayUpdateUserMsg ? onSelectExistingUser : onConfirm}
      confirmText={displayUpdateUserMsg ? 'Modifier l\'utilisateur' : null}
      loading={loading}
    >
      <p className="!mb-5">{isEditMode ? <span>Gérez les rôles de <span className="font-bold">{prop('email', selectedUser)}</span> sur les différentes offres</span> : 'Invitez un nouvel utilisateur et assignez lui des rôles pour une offre / équipe'}</p>
      {!isEditMode && (
        <div className="border-b-1 pb-5">
          <label>Adresse email</label>
          <Input
            className="!mt-2" 
            placeholder="jean.dupont@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      )}

      {!displayUpdateUserMsg ? (
        <div>
          <RoleCardList roles={rolesDisplayed} onDelete={onDelete} isAdministration={isAdministration} />
          <div className="flex flex-col gap-4 pt-5 border-t-1">
            <div className={isAdministration ? 'grid grid-cols-2 gap-2' : 'flex flex-col md:flex-row gap-2'}>
              {isAdministration && (
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  options={teamsOption}
                  value={selectedTeam || 'Équipe'}
                  onChange={setSelectedTeam}
                  disabled={disabledTeamSelect}
                />
              )}
              <Select
                allowClear
                options={rolesOption}
                value={selectedRole || 'Rôle'}
                onChange={setSelectedRole}
                disabled={disabledRoleSelect}
              />
              <div className={isAdministration ? 'col-span-2' : ''}>
                <Select
                  className="w-full"
                  mode="multiple"
                  allowClear
                  showSearch
                  showArrow
                  placeholder="Offres"
                  optionFilterProp="label"
                  options={offersOption}
                  value={selectedOffers}
                  onChange={setSelectedOffers}
                  disabled={disabledOfferSelect}
                />
              </div>
            </div>
            <div className="flex justify-between">
              <Button
                size="small"
                className="btn-add-role small-white-button"
                onClick={() => onAdd({
                  selectedTeam,
                  selectedOffers,
                  selectedRole
                })}
                disabled={disabledAddRoleBtn}
              >+ Ajouter le rôle
              </Button>
              {isAdministration && (
                <Button
                  type="primary" className="btn-super-admin" onClick={onAddSuperAdmin}
                  disabled={disableForm}
                ><SafetyOutlined /> Définir comme super admin
                </Button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Alert
          showIcon
          title="Info Title"
          description={existingUserDescription}
          type="info"
        />
      )}
    </BaseModal>
  );
};

export default withUser(UserModal);